import React from 'react';

import { parameters, strings } from '../../localization/strings';
import Heading1 from '../../components/common/headings/heading1';
import ContainerMd from '../../components/common/containers/containerMd';
import ExternalText from '../../components/text/external-text';
import { useSite } from '../../hooks/use-site';
import TextTerms from '../../components/text/self-co-terms';
import TextPrivacyPolicy from '../../components/text/self-co-privacy-policy';

interface ComponentProps {
  type: string;
}

export default function TextPageComponent({ type }: ComponentProps) {
  const { isSelfCo } = useSite();

  if (type === 'privacy') {
    return (
      <ContainerMd>
        <div className={`text-page ${isSelfCo ? 'text-page--self-co' : ''}`}>
          <Heading1>{strings()?.textPage?.privacyPolicy?.title || 'Privacy Policy'}</Heading1>

          {isSelfCo ? <TextPrivacyPolicy /> : <ExternalText url={parameters()?.textPage?.privacyPolicy || ''} />}
        </div>
      </ContainerMd>
    );
  }

  if (type === 'terms') {
    return (
      <ContainerMd>
        <div className="text-page">
          <Heading1>{strings()?.textPage?.termsAndConditions?.title || 'Terms and Conditions'}</Heading1>
          {isSelfCo ? <TextTerms /> : <ExternalText url={parameters()?.textPage?.privacyPolicy || ''} />}
        </div>
      </ContainerMd>
    );
  }

  return <div>Empty page</div>;
}
